'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { ButtonElement } from './elements';
import { InternalProvider, useDeviceDetect } from '../../util';
import { DEFAULT_BUTTON_COLOR, DEFAULT_BUTTON_SIZE, DEFAULT_BUTTON_VARIANT } from './types';
export const CoreButton = /*#__PURE__*/React.forwardRef(({
  variant = DEFAULT_BUTTON_VARIANT,
  color = DEFAULT_BUTTON_COLOR,
  ariaLabel,
  size = DEFAULT_BUTTON_SIZE,
  children,
  hasChildren = true,
  iconSide = 'left',
  hasIcon = false,
  options = {
    useFigmaStyles: false
  },
  ...rest
}, fRef) => {
  const {
    isMobile
  } = useDeviceDetect();
  return /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(ButtonElement, _extends({
    ref: fRef,
    "aria-label": ariaLabel,
    size: size,
    variant: variant,
    color: color,
    hasChildren: hasChildren,
    iconSide: iconSide,
    hasIcon: hasIcon,
    useFigmaStyles: options.useFigmaStyles,
    isMobile: isMobile
  }, rest), children));
});